import { Button, Checkbox, Col, Form, Input, Row, Tree } from "antd";
import styles from "../../Notice/Step/index.module.css";
import React, { useEffect, useState, useContext, useMemo } from "react";
import { NoticeV2Context } from "../index";

// 根据传入的options列表过滤值
const filterArr = (arr=[],options=[])=>{
  let newValue = [];
  const getOptions = (list) =>{
    list.map(i =>{
      if (i.children) {
        getOptions(i.children);
      }
      newValue.push(i.key);
      return i;
    })
    return newValue;
  }
  const keys = getOptions(options);
  return arr?.filter(i=>keys.includes(i)) || []
}

const sameKeys = (left = [], right = []) => (
  left.length === right.length && left.every((key, index) => key === right[index])
);
// 组装tree数据
const getTreeList = (list) => {
    return list?.map((i) => {
      i.key = i.key || i?.label?.replace(/ /g, "");
      if (i.children) {
        i.children = getTreeList(i.children);
      }
      return i;
    });
  };
// 封装tree
const getTree = (treeData = [], options = {}) => {
  return (
    <Tree
      checkable
      defaultExpandAll
      multiple
      autoExpandParent={true}
      fieldNames={{ title: "label", }}
      switcherIcon=""
      titleRender={({ label, other,key}) => {
        const isChecked = options.checkedKeys.includes(key);
        return (
          <div className={styles.center} >
            <span>{label}</span>
            {other && other(isChecked)}
          </div>
        );
      }}
      treeData={treeData}
      {...options}
    />
  );
};

// 横向展示两个tree，值合并为一个数组，只有一个options时，默认展示一个tree
const MergeTwoTree = ({
  options,
  options2,
  onChange,
  value,
}) => {
  const newOptions = getTreeList(options);
  const newOptions2 = getTreeList(options2);

  const [leftKeys, setLeftKeys] = useState([]);
  const [rightKeys, setRightKeys] = useState([]);

  // Form values arrive asynchronously after the disposition-notice request.
  // Keep the tree selection in sync when those values are populated.
  useEffect(()=>{
    const nextLeftKeys = filterArr(value, newOptions) || [];
    const nextRightKeys = filterArr(value, newOptions2) || [];
    setLeftKeys((current) => sameKeys(current, nextLeftKeys) ? current : nextLeftKeys);
    setRightKeys((current) => sameKeys(current, nextRightKeys) ? current : nextRightKeys);
  },[value]);

  const emitChange = (nextLeftKeys, nextRightKeys) => {
    const nextValue = [...new Set([...nextLeftKeys, ...nextRightKeys])];
    const currentValue = Array.isArray(value) ? value : [];
    if (onChange && !sameKeys(nextValue, currentValue)) {
      onChange(nextValue);
    }
  };

  const onSelect = (key, checkedKeys, setFun, otherKeys, isLeft) => {
    let newCheckedKeys = [...checkedKeys];
    if (checkedKeys.includes(key)) {
      // 已勾选则取消
      newCheckedKeys = newCheckedKeys.filter(k => k !== key);
    } else {
      // 未勾选则添加
      newCheckedKeys.push(key);
    }
    setFun(newCheckedKeys);
    emitChange(isLeft ? newCheckedKeys : otherKeys, isLeft ? otherKeys : newCheckedKeys);
  };

  const treeDom = getTree(newOptions, {
    checkedKeys: leftKeys,
    selectedKeys: leftKeys,
    onCheck: (keys) => {
      setLeftKeys(keys);
      emitChange(keys, rightKeys);
    },
    onSelect:(selectedKeys,info)=>onSelect(info.node.key, leftKeys, setLeftKeys, rightKeys, true)
  })
  return (options?.length&&!options2?.length?treeDom:(
    <Row>
      <Col md={12} xs={24}>
        {treeDom}
      </Col>
      <Col md={12} xs={24}>
        {getTree(newOptions2, {
          checkedKeys: rightKeys,
          selectedKeys: rightKeys,
          onCheck: (keys) => {
            setRightKeys(keys);
            emitChange(leftKeys, keys);
          },
           onSelect:(selectedKeys,info)=>onSelect(info.node.key, rightKeys, setRightKeys, leftKeys, false)
        })}
      </Col>
    </Row>
  ));
};

const Step2 = () => {
 const {form, setActiveKey ,saveDetails ,updateLoading, scrollTop} = useContext(NoticeV2Context);
 const inputFunction = (name,isChecked) =>{
    return (
       <Form.Item name={name} className={styles.otherInputForm} onClick={(e)=>{
           e.preventDefault();   
           e.stopPropagation(); 
       }}>
         <Input size="larg" disabled={!isChecked}/>
       </Form.Item>
     );
 }
  const getFormInput = (name,)=>{
     return (isChecked)=>inputFunction(name,isChecked);
  };

  const options1 = [
    { label: "No Credit File" },
    { label: "Insufficient No. of Credit Reference Provided" },
    { label: "Unacceptable Type of Credit Reference Provided" },
    { label: "Unable to Verify Credit Reference" },
    { label: "Limited Credit Experience" },
    { label: "Poor Credit Performance with Us" },
    { label: "Garnishment, Attachment" },
    { label: "Foreclosure or Repossession" },
    { label: "Other", other: getFormInput(["L2", "creditInput"]) },
  ];

  const options2 = [
    {
      label: "Excessive Obligations",

      children: [
        { label: "Excessive Obligations in Relation to Income" },
        {
          label: "Unacceptable Payment Record on Previous Mortgage",
        },
        { label: "Lack of Cash Reserve" },
      ],
    },
    {
      label: "Delinquent Past or Present Obligations with Others ",
    },
    { label: "Bankruptcy" },
    { label: "Collection Action or Judgment" },
    { label: "No. of Recent Inquires on Credit Bureau Report " },
  ];

  const bOptions = [
    { label: "Unable to Verify Employment" },
    { label: "Length of Employment" },
    {
      label:
        "Temporary or Irregular Employment. Insufficient Stability of Income. ",
    },
    { label: "Other", other: getFormInput(["L2", "employmentStatusInput"]) },
  ];

  const cOptions = [
    { label: "Income Insufficient for Amount of Credit Requested " },
    { label: "Unable to Verify Income" },
    { label: "Other", other: getFormInput(["L2", "incomeInput"]) },
  ];

  const dOptions = [
    { label: "Temporary Residence" },
    { label: "Too short a Period of Residence" },
    { label: "Unable to Verify Residence " },
    { label: "Other", other: getFormInput(["L2", "residencyInput"]) },
  ];

  const eOptions = [
    { label: "Department of Housing and Urban Dev" },
    { label: "Department of Veterans Affairs" },
    { label: "Federal National Mortgage Association" },
    { label: "Federal Home Loan Mortgage Corporation " },
    {
      label: "Other",
      other: getFormInput(["L2", "insuranceGuarantyOrPurchaseDeniedByInput"]),
    },
  ];

  const fOptions = [
    { label: "Insufficient Funds to Close the Loan" },
    { label: "Credit Application Incomplete " },
    {
      label: "Inadequate Collateral",
      children: [
        { label: "Unacceptable Property" },
        { label: "Value or Type of Collateral not Sufficient " },
        { label: "Insufficient Data - Property" },
        { label: "Unacceptable Appraisal" },
        { label: "Unacceptable Leasehold Estate" },
      ],
    },
  ];
  const fOptions2 = [
    {
      label:
        "We do not grant credit to any applicant on the terms and conditions you have requested",
    },
    { label: "Withdrawn by Applicant" },
    { label: "Other", other: getFormInput(["L2", "otherInput"]) },
    { label: "Other", key: 'AdditionalReasons',other: getFormInput(["L2", "additionalReasonsInput"]) },
  ];
  return (
    <Row className={[styles.step, styles.step2].join(" ")}>
      <Col className={styles.title} span={24} offset={0}>
        Part 1 - Principal Reasons for Denial, Termination, or Other Action
        Taken:
      </Col>
      <Col md={24} xs={24}>
        <Form.Item label="A. CREDIT" name={["L2", "credit"]}>
          <MergeTwoTree options={options1} options2={options2} />
        </Form.Item>
      </Col>
      <Col md={12} xs={24}>
        <Form.Item
          label="B. EMPLOYMENT STATUS"
          name={["L2", "employmentStatus"]}
        >
          <MergeTwoTree options={bOptions} />
        </Form.Item>
      </Col>
      <Col md={12} xs={24}>
        <Form.Item label="C. INCOME" name={["L2", "income"]} >
           <MergeTwoTree options={cOptions} />
        </Form.Item>
      </Col>
      <Col md={12} xs={24}>
        <Form.Item label="D. RESIDENCY" name={["L2", "residency"]} >
           <MergeTwoTree options={dOptions} />
        </Form.Item>
      </Col>
      <Col md={12} xs={24}>
        <Form.Item
          label="E.INSURANCE,GUARANTY OrPURCHASE DENIED BY:"
          name={["L2", "insuranceGuarantyOrPurchaseDeniedBy"]}
        >
           <MergeTwoTree options={eOptions} />
        </Form.Item>
      </Col>
      <Col md={24} xs={24}>
        <Form.Item label="F. OTHER" name={["L2", "other"]}>
          <MergeTwoTree options={fOptions} options2={fOptions2} />
        </Form.Item>
      </Col>
      <Col className={styles.optionBtn} span={24}>
        <Button type="link" size="large" onClick={() => {
          setActiveKey("1");
          scrollTop();
        }}>
          Back
        </Button>
        <Button type="primary" loading={updateLoading} size="large" onClick={async()=>{
          await saveDetails();
          setActiveKey('3');
          scrollTop();
        }}>
          Next
        </Button>
      </Col>
    </Row>
  );
};
export default Step2;
